<ion-app>
  <ion-router-outlet [swipeGesture]="false"></ion-router-outlet>
  <div
    *ngIf="(customerSwitchStatus$ | async) === 'pending'"
    class="block-ui-overlay"
  ></div>
</ion-app>
